import { Component, ViewEncapsulation, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'inactive-tenant',
    templateUrl: 'inactive.tenant.component.html',
    styleUrls: ['inactive.tenant.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class InactiveTenantComponent {

    @HostBinding('class.modern-form') modern = true;
}
